import React from 'react';
import {Comment, Reply} from '../api/Models';
import {useEnvironment, useNiceDateTime} from "@webng/react-app-common";
import {useTranslation} from "react-i18next";
import {PreformattedText} from "./PreformattedText";
import {Edit} from "react-feather";

export function exactSizeImageUrl(apiHost: string, url: string|undefined, width: number, height: number): string|undefined {
  if(url) {
    return apiHost + `/mediagw/image/w_${width},h_${height},c_fill/${url}`
    // return apiHost + "/api/mediaproxy/v1/external-image/ThumbnailatorCropResizeCenterFillFilter/w" + width + "dp-h" + height + "dp?url=" + encodeURIComponent(url)
  } else {
    return undefined
  }
}

export default function CommentRow({comment, onCommentManage}: {comment: Comment, onCommentManage?: (commentId: string) => void}){
  const {date, time, isoString} = useNiceDateTime(comment.createdAt);
  const {t} = useTranslation("liveblog");
  const {apiHost} = useEnvironment();

  let imageUrl = exactSizeImageUrl(apiHost, comment.author?.imageUrl, 100, 100)

  return <div className="tik4-comment" key={comment.id}>
    <div className="tik4-comment__container">
        { !comment.hidden && imageUrl &&
          <div className="tik4-comment__author-thumb"><img className="tik4-comment__author-thumb__img" src={imageUrl} alt="" /></div>
        }
      <div className="tik4-comment__body">
        <div className="tik4-comment__content">

          {comment.hidden ?
              <div className="tik4-comment__deleted">
                {t('liveblog.comments.comment.deleted')}
              </div>
            :
              <>
                <div className="tik4-comment__author">{comment.author?.name}</div>
                <div className="tik4-comment__text"><PreformattedText text={comment.text} /></div>
              </>
          }

        </div>
        {comment.starred &&
          <div className="tik4-comment__highlight"></div>
        }
      </div>
      <div className="tik4-comment__footer">
        <div className="tik4-comment__footer__left">
          { !!comment.originalText && !comment.hidden && <>
            <div className="tik4-comment__status tik4-comment__status--revised">{t('liveblog.comments.comment.footer.revised')}</div>
            <div className="tik4-comment__footer-divider"></div>
          </>}
          <div className="tik4-comment__timestamp">
            <time dateTime={isoString}>{date && <span>{date} </span>}{time && <span>{time}</span>}</time>
          </div>
        </div>
        <div className="tik4-comment__footer-right">
          {/* TODO: Timo styling */}
          {onCommentManage && <div className="relative"><button className="absolute right-0 top-0 -mt-4 btn btn-sm btn-link-muted px-2 py-0 -mr-2" onClick={() => onCommentManage(comment.id)} type="button"><Edit className="icon icon-btn-only" /></button></div>}
        </div>
      </div>
    </div>

    {comment.reply && <CommentReply reply={comment.reply} />}
  </div>
}

function CommentReply({reply}: {reply: Reply}){
  const {date, time} = useNiceDateTime(reply.createdAt);
  const {t} = useTranslation("liveblog");
  const {apiHost} = useEnvironment()

  let imageUrl = exactSizeImageUrl(apiHost, reply.author.imageUrl, 100, 100)

  return <div className="tik4-comment__reply">
    { imageUrl ?
        <div className="tik4-comment__author-thumb tik4-comment__author-thumb--reply"><img className="tik4-comment__author-thumb__img" src={imageUrl} alt="" /></div>
      :
        <div className="tik4-comment__author-thumb tik4-comment__author-thumb--reply-placeholder"></div>
    }

    <div className="tik4-comment__reply-container">
      <div className="tik4-comment__body tik4-comment__body--reply">
        <div className="tik4-comment__content">
          {reply.author &&
          <div className="tik4-comment__author">{reply.author.name}</div>
          }
          <div className="tik4-comment__text"><PreformattedText text={reply.text} /></div>
        </div>
      </div>
      <div className="tik4-comment__footer">
        <div className="tik4-comment__footer__left">
          <div className="tik4-comment__footer-author">{t('liveblog.comments.reply.editors')}</div>
          <div className="tik4-comment__footer-divider"></div>
          <div className="tik4-comment__timestamp"><span>{date && <span>{date} </span>}{time && <span>{time}</span>}</span></div>
        </div>
      </div>
    </div>
  </div>
}
